import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type {
  CompanyOption,
  Facility,
  FacilityCreateInput,
  FacilityRole,
  FacilityUpdateInput,
} from './types';

export interface FacilityListParams {
  active_only?: boolean;
  q?: string;
  company_party_type?: CompanyOption['party_type'];
  facility_role?: FacilityRole;
}

export const listFacilities = async (params: FacilityListParams = {}): Promise<Facility[]> => {
  const res = await apiClient.get<ApiSuccess<Facility[]>>('/facilities', { params });
  return res.data.data ?? [];
};

export const createFacility = async (body: FacilityCreateInput): Promise<Facility> => {
  const res = await apiClient.post<ApiSuccess<Facility>>('/facilities', body);
  return res.data.data;
};

export const updateFacility = async (id: string, body: FacilityUpdateInput): Promise<Facility> => {
  const res = await apiClient.put<ApiSuccess<Facility>>(`/facilities/${id}`, body);
  return res.data.data;
};

/** Permanent removal. Only succeeds for a deactivated, unreferenced facility. */
export const purgeFacility = async (id: string): Promise<void> => {
  await apiClient.delete(`/facilities/${id}/purge`);
};

export const deactivateFacility = async (id: string): Promise<void> => {
  await apiClient.delete(`/facilities/${id}`);
};

export const activateFacility = async (id: string): Promise<Facility> => {
  const res = await apiClient.put<ApiSuccess<Facility>>(`/facilities/${id}`, {
    active_flag: true,
  });
  return res.data.data;
};

export interface CompanyOptionListParams {
  party_type?: CompanyOption['party_type'];
}

export const listCompanyOptions = async (
  params: CompanyOptionListParams = {},
): Promise<CompanyOption[]> => {
  const res = await apiClient.get<ApiSuccess<CompanyOption[]>>('/companies', {
    params: { active_only: true, per_page: 200, ...params },
  });
  return res.data.data ?? [];
};
